module.exports = __webpack_public_path__ + "static/C2021_ISTVS_abs-3efa9e418d2f659ceff01d943b9288dd.gif";